import { CURRENCY_EUR } from "consts"

export const BILLING_TYPE_SUBSCRIPTION = "BILLING_TYPE_SUBSCRIPTION"

export const BILLING_CURRENCY = CURRENCY_EUR
